import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Resolves relative backend image URLs ("/uploads/...") against the API origin.
 * In production (Vercel) the frontend and backend live on different domains,
 * so relative paths must be prefixed with the backend origin from VITE_API_URL.
 */
export function resolveImageUrl(url: string): string {
  if (!url.startsWith("/uploads")) return url;
  const apiOrigin = new URL(
    import.meta.env.VITE_API_URL || "/api/v1",
    window.location.origin
  ).origin;
  return `${apiOrigin}${url}`;
}
